export default "__VITE_ASSET__BF3Uo1AW__"